/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacthirelawyertitle3Inputs */

const en_artifacthirelawyertitle3 = /** @type {(inputs: Artifacthirelawyertitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hire a partner lawyer`)
};

const pt_artifacthirelawyertitle3 = /** @type {(inputs: Artifacthirelawyertitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contratar advogado parceiro`)
};

/**
* | output |
* | --- |
* | "Hire a partner lawyer" |
*
* @param {Artifacthirelawyertitle3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifacthirelawyertitle3 = /** @type {((inputs?: Artifacthirelawyertitle3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacthirelawyertitle3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifacthirelawyertitle3(inputs)
	return pt_artifacthirelawyertitle3(inputs)
});
export { artifacthirelawyertitle3 as "artifactHireLawyerTitle" }